import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStar = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_3260_63432)",
			children: /* @__PURE__ */ _jsx("path", { d: "M11.9294 1.04554C12.0646 0.683937 12.5761 0.683936 12.7113 1.04554L15.186 7.66381C15.2447 7.82068 15.3914 7.9273 15.5587 7.93461L22.6178 8.24307C23.0035 8.25992 23.1616 8.74637 22.8594 8.9867L17.3298 13.3855C17.1987 13.4897 17.1427 13.6623 17.1875 13.8236L19.0755 20.6325C19.1786 21.0046 18.7648 21.3052 18.4429 21.0921L12.5507 17.1925C12.411 17.1 12.2296 17.1 12.09 17.1925L6.19773 21.0921C5.8758 21.3052 5.462 21.0046 5.56516 20.6325L7.45317 13.8236C7.49793 13.6623 7.44187 13.4897 7.3108 13.3855L1.78119 8.98671C1.47907 8.74637 1.63712 8.25992 2.02282 8.24307L9.08189 7.93461C9.24922 7.9273 9.39597 7.82068 9.45463 7.66381L11.9294 1.04554Z" })
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_3260_63432",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgStar);
export { ForwardRef as ReactComponent };
